import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FireflySingleSuggesterComponent } from '../single-suggester/single-suggester.component';

@Component({
  selector: 'f-single-suggester-with-icon',
  templateUrl: './single-suggester-with-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireflySingleSuggesterWithIconComponent extends FireflySingleSuggesterComponent {
  @Input() iconClass: string = 'f-i-trash-bin';
  @Input() iconTooltip: string = '';
  @Output() iconClick = new EventEmitter<unknown>();

  onIconClick(item: unknown, $event: Event): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.iconClick.emit(item);
  }
}
